import { Observable, Subject } from 'rxjs';

import { IIpaNetworkMapping, IpaNetworkMappingSelectedData, IIpaNetworkMappingSubmitResponse } from 'components/ProviderData/IpaAdministration/atoms/Models';

export interface SubmitNetworkMappingServerResponse {
    requestFailed: boolean;
    requestErrorMessage?: string;
    data?: IIpaNetworkMappingSubmitResponse;
}
const selectedNetworkMapping = new Subject<IpaNetworkMappingSelectedData>();
const submitNetworkMapping = new Subject<SubmitNetworkMappingServerResponse | void>();

const IpaNetworkMappingService = {
    select: (network: IIpaNetworkMapping, tabId: string) => {
        selectedNetworkMapping.next({ipaNetworkMappingItem: network, tabId });
    },
    get$: (): Observable<IpaNetworkMappingSelectedData> => selectedNetworkMapping.asObservable(),
    submit: (response: SubmitNetworkMappingServerResponse | void) => submitNetworkMapping.next(response),
    submit$: (): Observable<SubmitNetworkMappingServerResponse | void> => submitNetworkMapping.asObservable(),
};

export { IpaNetworkMappingService };
